module.exports = __webpack_public_path__ + "img/20190531173334微信图片_20190531173631.980a9db5.jpg";